import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../../index'

const variables = (state: RootState) => state.editor.variables
const activeEditorInstance = (state: RootState) =>
  state.editor.activeEditorInstance
const activeEditorSelectionRange = (state: RootState) =>
  state.editor.activeEditorSelectionRange
const initialResourceData = (state: RootState) =>
  state.editor.initialResourceData
const initialFilteredResourceData = (state: RootState) =>
  state.editor.initialFilteredResourceData
const template = (state: RootState) => state.editor.template

export const variablesSelector = createSelector(
  [variables],
  variables => variables,
)

export const initialFilteredResourceDataSelector = createSelector(
  [initialFilteredResourceData],
  initialFilteredResourceData => initialFilteredResourceData,
)

export const activeEditorInstanceSelector = createSelector(
  [activeEditorInstance],
  activeEditorInstance => activeEditorInstance,
)

export const activeEditorSelectionRangeSelector = createSelector(
  [activeEditorSelectionRange],
  activeEditorSelectionRange => activeEditorSelectionRange,
)

export const initialResourceDataSelector = createSelector(
  [initialResourceData],
  initialResourceData => initialResourceData,
)

export const editorTemplateSelector = createSelector(
  [template],
  template => template,
)

const autosaveStatus = (state: RootState) => state.editor.autosaveStatus
const autosaveLastSavedAt = (state: RootState) =>
  state.editor.autosaveLastSavedAt

export const autosaveStatusSelector = createSelector(
  [autosaveStatus],
  status => status,
)

export const autosaveLastSavedAtSelector = createSelector(
  [autosaveLastSavedAt],
  lastSavedAt => lastSavedAt,
)
